import {
    IonCard,
    IonCardContent,
    IonCol,
    IonContent,
    IonPage,
    IonRow,
} from "@ionic/react";
import Header from "../../../../../components/Headers/Header";
import PageTitle from "../../../../../components/PageTitle/PageTitle";
import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { getOrganizationById } from "../../../../../utilities/organization/Organization";
import { Organization, Season } from "../../../../../models";
import Spinner from "../../../../../components/Spinners/Spinner";
import ErrorAlert from "../../../../../components/Errors/ErrorAlert";
import SeasonForm from "../../../../../components/Season/SeasonForm";
import { getSeasonById } from "../../../../../utilities/seasons/Seasons";

interface _Props extends RouteComponentProps<{
    id: string;
}> {}

const EditSeasonPage: React.FC<_Props> = ({match}) => {

    const [organization, setOrganization] = useState<Organization | null>(null);
    const [season, setSeason] = useState<Season | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");

    useEffect(() => {
        async function getOrganization() {
            if(season?.organizationId) {
                setIsLoading(true);
                const queryResult = await getOrganizationById(season.organizationId);
                if (queryResult.isSuccess) {
                    setOrganization(queryResult.result);
                } else {
                    setError(queryResult.message);
                }
                setIsLoading(false);
            }
        }
        getOrganization();
    }, [season]);
    
    useEffect(() => {
        async function getSeason() {
            setIsLoading(true);
            const queryResult = await getSeasonById(match.params.id);
            if (queryResult.isSuccess) {
                setSeason(queryResult.result);
            } else {
                setError(queryResult.message);
            }
            setIsLoading(false);
        }
        getSeason();
    }, [match, match.params.id]);

   
    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                {error && <ErrorAlert width="12" error={error} />}
                <PageTitle title={`${(organization?.nickname || organization?.name) ?? ""}`} />
                <IonRow className="ion-justify-content-center">
                    <IonCol sizeXs="12" sizeMd="12">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardContent>
                                {organization && season && !isLoading ?
                                    <SeasonForm season={season} organization={organization}  headerTitle="Edit Season"/>
                                :   
                                    <Spinner/> 
                                }
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default EditSeasonPage;
